import React from "react";
import PropTypes from "prop-types";
import { isNull } from "lodash";

import { ArrayText, DateText, Label } from "..";

export function TextValue({ type, value, prefix, ...props }) {
  const text = () => {
    switch (type?.id) {
      case "DROPDOWN":
      case "MULTISELECT_DROPDOWN":
        return <ArrayText value={value} {...props} />;
      case "DATE":
        return <DateText value={value} formatString="MM/dd/yyyy" {...props} />;
      case "DATETIME":
        return <DateText value={value} {...props} />;
      default:
        return value?.toString()?.trim() ? (
          <Label basic color="grey" {...props}>
            {value?.toString()?.trim()}
          </Label>
        ) : (
          ""
        );
    }
  };

  const textValue = text();
  return (
    !isNull(value) &&
    textValue && (
      <React.Fragment>
        {prefix ? `${prefix} ` : ""}
        <b>{textValue}</b>
      </React.Fragment>
    )
  );
}

TextValue.propTypes = {
  type: PropTypes.shape({ id: PropTypes.string }),
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.instanceOf(Date),
  ]),
  prefix: PropTypes.string,
};

TextValue.defaultProps = {
  type: null,
  value: null,
  prefix: "options",
};

export default TextValue;
